import type { Partner } from '@oneaudi/audi-partner-utils/lib/types';
import { createDirectionsLink, createMyAudiLink } from './PartnerLinks';

export type PbcPartner = {
  partnerId: string;
  officialName: string;
  displayName?: string;
  locationName?: string | null;
  address: string[];
  phone?: string | null;
  fax?: string;
  url?: string | null;
  email?: string | null;
  locationImageUrl: string;
  vCardUrl: string;
  myAudiUrl: string;
  directionsUrl: string;
  services: string[];
  additionalServices?: string[];
  openingHours?: PartnerOpeningHours | null;
  long?: number;
  lat?: number;
  nameEnhanced: string;
};

export type PartnerOpeningHours = {
  openingHoursNote?: string;
  departments: DepartmentOpeningHours[];
};

export type DepartmentOpeningHours = {
  id?: string;
  departmentName: string;
  departmentOpeningHoursNote?: string;
  openingHours: DayOpeningHours[];
};

export type DayOpeningHours = {
  id: WeekDay;
  open: boolean;
  timeRanges?: TimeRange[];
};

export type TimeRange = {
  openTime?: string;
  closeTime?: string;
};

export type WeekDay =
  | 'monday'
  | 'tuesday'
  | 'wednesday'
  | 'thursday'
  | 'friday'
  | 'saturday'
  | 'sunday';

export const createPartner = (data: Partner | undefined): PbcPartner | undefined => {
  if (!data) {
    return undefined;
  }

  let nameEnhanced = data.additionalData?.displayName || data.name;
  if (data.additionalData && data.additionalData.locationName) {
    nameEnhanced += ` ${data.additionalData.locationName}`;
  }

  return {
    partnerId: data.dealerId,
    officialName: data.name,
    displayName: data.additionalData?.displayName || data.name,
    locationName: data.additionalData?.locationName,
    address: data.address,
    phone: data.phone,
    url: data.url || data.additionalData?.additionalUrl,
    email: data.email,
    locationImageUrl: data.additionalData?.locationImage || '',
    vCardUrl: data.vCardUrl || '',
    myAudiUrl: createMyAudiLink(data),
    directionsUrl: createDirectionsLink(data),
    services: data.services,
    additionalServices: data.additionalData?.additionalServices || [],
    openingHours: data.openingHours as PartnerOpeningHours,
    long: data.longitude,
    lat: data.latitude,
    nameEnhanced,
  };
};
